import _get from 'lodash/get';
import _every from 'lodash/every';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';
import _sumBy from 'lodash/sumBy';

const isSameAddons = (deliveryAddons, toCompareAddons) => {
  if (deliveryAddons.length !== toCompareAddons.length) {
    return false;
  }
  return _every(
    toCompareAddons,
    toCompare => !!deliveryAddons.find(addons => addons.id === toCompare.id),
  );
};

const isSameConfigDelivery = (deliveryConfig, toCompareConfig) => {
  const deliveryServiceType = _get(deliveryConfig, ['serviceType']);
  const toCompareServiceType = _get(toCompareConfig, ['serviceType']);

  const deliveryVehicleType = _get(deliveryConfig, ['vehicleType']);
  const toCompareVehicleType = _get(toCompareConfig, ['vehicleType']);

  const deliveryScheduledPickupSlot = _get(deliveryConfig, [
    'scheduledPickupSlot',
  ]);
  const toCompareScheduledPickupSlot = _get(toCompareConfig, [
    'scheduledPickupSlot',
  ]);
  if (
    deliveryServiceType &&
    deliveryServiceType === toCompareServiceType &&
    deliveryVehicleType === toCompareVehicleType &&
    deliveryVehicleType === toCompareVehicleType &&
    _isEqual(deliveryScheduledPickupSlot, toCompareScheduledPickupSlot)
  ) {
    if (
      isSameAddons(
        _get(deliveryConfig, ['additionalServices'], []),
        _get(toCompareConfig, ['additionalServices'], []),
      )
    ) {
      return true;
    }
  }
  return false;
};

export const filterSameDelivery = (allDeliveries, deliveryIDs) => {
  const deliveryIDGroups = [];
  const proceedDeliveryIDs = [];
  deliveryIDs.forEach(deliveryID => {
    const delivery = allDeliveries.find(delivery => delivery.id === deliveryID);
    const deliveryConfig = _get(delivery, ['detail', 'configuration']);
    if (
      _get(delivery, ['detail', 'dropOffs', 'length'], 1) > 1 ||
      _get(deliveryConfig, ['serviceType']) !== 'INSTANT'
    ) {
      proceedDeliveryIDs.push(delivery.id);
      return;
    }
    const groups = [];
    deliveryIDs
      .filter(deliveryID => !proceedDeliveryIDs.includes(deliveryID))
      .forEach(compareDeliveryID => {
        if (deliveryID === compareDeliveryID) return;
        const toCompareDelivery = allDeliveries.find(
          delivery => delivery.id === compareDeliveryID,
        );

        const toCompareConfig = _get(toCompareDelivery, [
          'detail',
          'configuration',
        ]);
        if (isSameConfigDelivery(deliveryConfig, toCompareConfig)) {
          groups.push(compareDeliveryID);
        }
      });
    if (groups.length > 0) {
      groups.push(deliveryID);
      proceedDeliveryIDs.push(...groups);
      deliveryIDGroups.push(groups);
    }
  });
  return deliveryIDGroups;
};

export const calculateGroupingOptimizedAmount = ({
  allDeliveries,
  trialDeliveries,
  clusterMappings,
}) => {
  if (_isEmpty(allDeliveries) || _isEmpty(clusterMappings)) {
    // Short return for optimization
    return {
      currencyCode: undefined,
      originalAmount: 0,
      originalDeliveryCount: 0,
      optimisedAmount: 0,
      optimisedDeliveryCount: 0,
    };
  }

  const currencyCode = _get(allDeliveries, '[0].quote.currency.code');

  const originalAmount = _sumBy(allDeliveries, delivery =>
    _get(delivery, ['quote', 'originalFare', 'lowerBound'], 0),
  );

  const trialDeliveriesAmount = _sumBy(
    Object.values(trialDeliveries),
    delivery => {
      if (
        _get(delivery, ['quote', 'alternativeFare', 0, 'routeOptimization'])
      ) {
        return _get(
          delivery,
          ['quote', 'alternativeFare', 0, 'finalFare', 'lowerBound'],
          0,
        );
      }
      return _get(delivery, ['quote', 'originalFare', 'lowerBound'], 0);
    },
  );

  const flattenMapping = clusterMappings.reduce((set, mapping) => {
    _get(mapping, 'originalDeliveryIDs', []).forEach(deliveryID =>
      set.add(deliveryID),
    );
    return set;
  }, new Set());
  let nonOptimizedCount = 0;
  let nonOptimizedAmount = 0;
  allDeliveries.forEach(delivery => {
    if (!flattenMapping.has(delivery.id)) {
      nonOptimizedCount += 1;
      nonOptimizedAmount += _get(
        delivery,
        ['quote', 'originalFare', 'lowerBound'],
        0,
      );
    }
  });

  return {
    currencyCode,
    originalAmount,
    originalDeliveryCount: allDeliveries.length,
    optimisedAmount: nonOptimizedAmount + trialDeliveriesAmount,
    optimisedDeliveryCount:
      Object.values(trialDeliveries).length + nonOptimizedCount,
  };
};

export default {};
